import {
  GET_LEAD_PROFILE_STICKY_COLUMNS,
  GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
  GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_lead_profile: null,
  loading: false
}

const UserLeadProfileColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_PROFILE_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_lead_profile: action.payload,
        loading: false
      }

    case GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_LEAD_PROFILE_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_lead_profile: action.payload,
        loading: false
      }

    case UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserLeadProfileColumnPreference;
